<template>
  <div>
    <svg :width="width" :height="height">
      <use v-bind="{'xlink:href':'/svg/sprite.svg#' + name}"></use>
    </svg>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'IconSvg',
  props: {
    name: String,
    width: {
      type: [Number, String],
      default: 16
    },
    height: {
      type: [Number, String],
      default: 16
    }
  }
}
</script>

<style scoped>
</style>
